/**
 * The Mastery Partners diamond mark, as geometry.
 *
 * One definition for all three places that draw it — the widget intro, the
 * verifying animation and the admin masthead — so they cannot drift apart.
 * Measurements and the full derivation live in brand/BRAND_GUIDE.md; the short
 * version is that this was traced off the supplied artwork by scanline rather
 * than eyeballed, and normalised so the outer half-diagonal is 100.
 *
 * The mark is a WEAVE. Two diamond rings offset horizontally, and where they
 * meet at their facing vertices each ring's upper stroke carries straight on
 * through the other's hole instead of turning the corner. Those are TAILS
 * below. Without them the lower hollows run too long and it reads as two loose
 * diamonds rather than an interlock.
 *
 * Single colour — the citron belongs to the rule in the wordmark and appears
 * nowhere in the mark.
 */

export const MARK_VIEWBOX = "0 0 267.05 200";

/** width / height, for sizing from a height. */
export const MARK_ASPECT = 267.05 / 200;

/**
 * The finished mark, filled. Relies on the nonzero fill rule (SVG's default):
 * outer rings and tails wound clockwise, inner rings counter-clockwise, so a
 * tail sums to +1 and fills while the centre — inside both holes — sums to 0
 * and punches through. `fill-rule: evenodd` would invert the tails.
 */
export const MARK_PATH = [
  "M100,0 L200,100 L100,200 L0,100 Z",
  "M100,30.31 L30.31,100 L100,169.69 L169.69,100 Z",
  "M167.05,0 L267.05,100 L167.05,200 L67.05,100 Z",
  "M167.05,30.31 L97.36,100 L167.05,169.69 L236.74,100 Z",
  "M67.05,100 L82.21,115.16 L63.84,133.53 L48.68,118.37 Z",
  "M200,100 L218.37,118.37 L203.22,133.53 L184.85,115.16 Z",
].join(" ");

/**
 * The same two rings expressed as centre-lines to be stroked, which is what
 * lets them be drawn on with stroke-dashoffset. Stroking these at
 * RING_STROKE with a miter join reproduces the rings exactly: the centre-line
 * sits at half-diagonal 84.85, and ±10.72 perpendicular lands on 100 and 69.69.
 *
 * The tails are not part of a ring's outline, so they cannot be drawn this way
 * — they arrive separately, which is exactly the moment the mark locks.
 */
export const RING_LEFT = "M100,15.15 L184.85,100 L100,184.85 L15.15,100 Z";
export const RING_RIGHT = "M167.05,15.15 L251.90,100 L167.05,184.85 L82.20,100 Z";
export const RING_STROKE = 21.43;

/** Path length of one ring's centre-line: four sides of 84.85 x sqrt(2). */
export const RING_PERIMETER = 480;

/** The two interlace tails, filled, once both rings are drawn. */
export const MARK_TAILS = [
  "M67.05,100 L82.21,115.16 L63.84,133.53 L48.68,118.37 Z",
  "M200,100 L218.37,118.37 L203.22,133.53 L184.85,115.16 Z",
].join(" ");
